import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CloudFunctionsService } from 'src/app/services/cloud-functions.service';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.scss']
})
export class ContactusComponent implements OnInit 
{
  constructor(
    private router : Router, 
    private route: ActivatedRoute,
    private localeservice: LocaleService) {  }

  ngOnInit(): void 
  {
    this.localeservice.setLocale("pt-BR", "BRL");
  }

  contactUs(): void
  {
    window.open("mailto:cgrape.inc@gmail.com", '_top');
  }
}
